// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2296":"941c99c6","3645":"fe52b40a","7505":"147ca0b7","8495":"ea31fa42"}[chunkId] + ".chunk.css";
};